import { generateClient, Client } from "aws-amplify/api";

let client: Client | undefined;

export const getGraphqlClient = (): Client => {
	if (!client) {
		// @ts-expect-error
		client = generateClient();
	}

	return client;
};
